import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-motivator',
  imports: [NgIf],
  templateUrl: './motivator.component.html',
  styleUrl: './motivator.component.scss',
})
export class MotivatorComponent implements OnChanges {
  @Input() config: any;
  @Input() cart: any;

  _message: string = '';
  _success: string = '';
  _total: any = 0;
  _maxthreshold: number = 0;
  _progress: any = 0;
  ngOnChanges(changes: SimpleChanges): void {
    this._total =
      parseFloat(this.cart?.cost?.subtotalAmount?.amount ?? '0') * 100;

    if (this.config?.motivator?.enabled !== true) return;
    this.config.motivator.stages.sort(
      (a: any, b: any) => a.threshold - b.threshold
    );
    this._success = '';
    this._message = '';
    for (let entry of this.config.motivator.stages) {
      if (this._total < entry.threshold) {
        this._message = entry.message;
      }
      if (this._total > entry.threshold) {
        this._success = entry.success;
      }
      this._maxthreshold = entry.threshold;
      this.processMessage(entry);
    }
  }

  processMessage(stage: any) {
    this._message = this._message.replace(
      '%amount%',
      '' +
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.cart.currency ?? 'USD',
        }).format((stage.threshold - this._total) / 100)
    );
  }

  processProgress(stage: any) {
    this._progress = this._total;
  }
}
